// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 544 ? "4f149b58" : chunkId) + "." + {"544":"e57765580e37fda2","593":"a25af7eabe009903","707":"c9cb7d3b4599949e","835":"59ee36bc07317207"}[chunkId] + ".js";
};